// src/common/utils/stateNameMapper.ts

export const GLOBAL_STATES: Record<string, Record<string, string>> = {
  US: {
    AL: "Alabama",
    AK: "Alaska",
    AZ: "Arizona",
    AR: "Arkansas",
    CA: "California",
    CO: "Colorado",
    CT: "Connecticut",
    DE: "Delaware",
    FL: "Florida",
    GA: "Georgia",
    HI: "Hawaii",
    ID: "Idaho",
    IL: "Illinois",
    IN: "Indiana",
    IA: "Iowa",
    KS: "Kansas",
    KY: "Kentucky",
    LA: "Louisiana",
    ME: "Maine",
    MD: "Maryland",
    MA: "Massachusetts",
    MI: "Michigan",
    MN: "Minnesota",
    MS: "Mississippi",
    MO: "Missouri",
    MT: "Montana",
    NE: "Nebraska",
    NV: "Nevada",
    NH: "New Hampshire",
    NJ: "New Jersey",
    NM: "New Mexico",
    NY: "New York",
    NC: "North Carolina",
    ND: "North Dakota",
    OH: "Ohio",
    OK: "Oklahoma",
    OR: "Oregon",
    PA: "Pennsylvania",
    RI: "Rhode Island",
    SC: "South Carolina",
    SD: "South Dakota",
    TN: "Tennessee",
    TX: "Texas",
    UT: "Utah",
    VT: "Vermont",
    VA: "Virginia",
    WA: "Washington",
    WV: "West Virginia",
    WI: "Wisconsin",
    WY: "Wyoming",
    DC: "District of Columbia",
  },
  CA: {
    AB: "Alberta",
    BC: "British Columbia",
    MB: "Manitoba",
    NB: "New Brunswick",
    NL: "Newfoundland and Labrador",
    NS: "Nova Scotia",
    ON: "Ontario",
    PE: "Prince Edward Island",
    QC: "Quebec",
    SK: "Saskatchewan",
    NT: "Northwest Territories",
    NU: "Nunavut",
    YT: "Yukon",
  },
  IN: {
    AN: "Andaman and Nicobar Islands",
    AP: "Andhra Pradesh",
    AR: "Arunachal Pradesh",
    AS: "Assam",
    BR: "Bihar",
    CH: "Chandigarh",
    CG: "Chhattisgarh",
    DN: "Dadra and Nagar Haveli",
    DD: "Daman and Diu",
    DL: "Delhi",
    GA: "Goa",
    GJ: "Gujarat",
    HR: "Haryana",
    HP: "Himachal Pradesh",
    JK: "Jammu and Kashmir",
    JH: "Jharkhand",
    KA: "Karnataka",
    KL: "Kerala",
    LD: "Lakshadweep",
    MP: "Madhya Pradesh",
    MH: "Maharashtra",
    MN: "Manipur",
    ML: "Meghalaya",
    MZ: "Mizoram",
    NL: "Nagaland",
    OR: "Odisha",
    PY: "Puducherry",
    PB: "Punjab",
    RJ: "Rajasthan",
    SK: "Sikkim",
    TN: "Tamil Nadu",
    TG: "Telangana",
    TR: "Tripura",
    UP: "Uttar Pradesh",
    UT: "Uttarakhand",
    WB: "West Bengal",
    LA: "Ladakh",
  },
  AU: {
    NSW: "New South Wales",
    VIC: "Victoria",
    QLD: "Queensland",
    WA: "Western Australia",
    SA: "South Australia",
    TAS: "Tasmania",
    ACT: "Australian Capital Territory",
    NT: "Northern Territory",
  },
  GB: {
    ENG: "England",
    SCT: "Scotland",
    WLS: "Wales",
    NIR: "Northern Ireland",
  },
  DE: {
    BW: "Baden-Württemberg",
    BY: "Bavaria",
    BE: "Berlin",
    BB: "Brandenburg",
    HB: "Bremen",
    HH: "Hamburg",
    HE: "Hesse",
    MV: "Mecklenburg-Vorpommern",
    NI: "Lower Saxony",
    NW: "North Rhine-Westphalia",
    RP: "Rhineland-Palatinate",
    SL: "Saarland",
    SN: "Saxony",
    ST: "Saxony-Anhalt",
    SH: "Schleswig-Holstein",
    TH: "Thuringia",
  },
  FR: {
    ARA: "Auvergne-Rhône-Alpes",
    BFC: "Bourgogne-Franche-Comté",
    BRE: "Brittany",
    CVL: "Centre-Val de Loire",
    COR: "Corsica",
    GES: "Grand Est",
    HDF: "Hauts-de-France",
    IDF: "Île-de-France",
    NOR: "Normandy",
    NAQ: "Nouvelle-Aquitaine",
    OCC: "Occitania",
    PDL: "Pays de la Loire",
    PAC: "Provence-Alpes-Côte d'Azur",
  },
  BR: {
    AC: "Acre",
    AL: "Alagoas",
    AP: "Amapá",
    AM: "Amazonas",
    BA: "Bahia",
    CE: "Ceará",
    DF: "Distrito Federal",
    ES: "Espírito Santo",
    GO: "Goiás",
    MA: "Maranhão",
    MT: "Mato Grosso",
    MS: "Mato Grosso do Sul",
    MG: "Minas Gerais",
    PA: "Pará",
    PB: "Paraíba",
    PR: "Paraná",
    PE: "Pernambuco",
    PI: "Piauí",
    RJ: "Rio de Janeiro",
    RN: "Rio Grande do Norte",
    RS: "Rio Grande do Sul",
    RO: "Rondônia",
    RR: "Roraima",
    SC: "Santa Catarina",
    SP: "São Paulo",
    SE: "Sergipe",
    TO: "Tocantins",
  },
  MX: {
    AG: "Aguascalientes",
    BC: "Baja California",
    BS: "Baja California Sur",
    CM: "Campeche",
    CS: "Chiapas",
    CH: "Chihuahua",
    CO: "Coahuila",
    CL: "Colima",
    DF: "Mexico City",
    DG: "Durango",
    GT: "Guanajuato",
    GR: "Guerrero",
    HG: "Hidalgo",
    JA: "Jalisco",
    ME: "México",
    MI: "Michoacán",
    MO: "Morelos",
    NA: "Nayarit",
    NL: "Nuevo León",
    OA: "Oaxaca",
    PU: "Puebla",
    QT: "Querétaro",
    QR: "Quintana Roo",
    SL: "San Luis Potosí",
    SI: "Sinaloa",
    SO: "Sonora",
    TB: "Tabasco",
    TM: "Tamaulipas",
    TL: "Tlaxcala",
    VE: "Veracruz",
    YU: "Yucatán",
    ZA: "Zacatecas",
  },
  CN: {
    BJ: "Beijing",
    TJ: "Tianjin",
    HE: "Hebei",
    SX: "Shanxi",
    IM: "Inner Mongolia",
    LN: "Liaoning",
    JL: "Jilin",
    HL: "Heilongjiang",
    SH: "Shanghai",
    JS: "Jiangsu",
    ZJ: "Zhejiang",
    AH: "Anhui",
    FJ: "Fujian",
    JX: "Jiangxi",
    SD: "Shandong",
    HA: "Henan",
    HB: "Hubei",
    HN: "Hunan",
    GD: "Guangdong",
    GX: "Guangxi",
    HI: "Hainan",
    CQ: "Chongqing",
    SC: "Sichuan",
    GZ: "Guizhou",
    YN: "Yunnan",
    XZ: "Tibet",
    SN: "Shaanxi",
    GS: "Gansu",
    QH: "Qinghai",
    NX: "Ningxia",
    XJ: "Xinjiang",
    HK: "Hong Kong",
    MO: "Macao",
  },
  JP: {
    HKD: "Hokkaido",
    AOM: "Aomori",
    IWT: "Iwate",
    MYG: "Miyagi",
    AKT: "Akita",
    YMG: "Yamagata",
    FKS: "Fukushima",
    IBR: "Ibaraki",
    TCG: "Tochigi",
    GNM: "Gunma",
    STM: "Saitama",
    CHB: "Chiba",
    TKY: "Tokyo",
    KNG: "Kanagawa",
    NIG: "Niigata",
    TYM: "Toyama",
    ISK: "Ishikawa",
    FKI: "Fukui",
    YMN: "Yamanashi",
    NGN: "Nagano",
    GIF: "Gifu",
    SZO: "Shizuoka",
    AIC: "Aichi",
    MIE: "Mie",
    SHG: "Shiga",
    KYT: "Kyoto",
    OSK: "Osaka",
    HYG: "Hyogo",
    NAR: "Nara",
    WKY: "Wakayama",
    TTR: "Tottori",
    SMN: "Shimane",
    OKY: "Okayama",
    HRS: "Hiroshima",
    YMGC: "Yamaguchi",
    TKS: "Tokushima",
    KGW: "Kagawa",
    EHM: "Ehime",
    KOC: "Kochi",
    FKO: "Fukuoka",
    SAG: "Saga",
    NGS: "Nagasaki",
    KMM: "Kumamoto",
    OIT: "Oita",
    MYZ: "Miyazaki",
    KGS: "Kagoshima",
    OKN: "Okinawa",
  },
  RU: {
    MOW: "Moscow",
    SPE: "Saint Petersburg",
    KGD: "Kaliningrad",
    ROS: "Rostov",
    KRA: "Krasnodar",
    EKB: "Ekaterinburg",
    NSK: "Novosibirsk",
    KZN: "Kazan",
    NIZ: "Nizhny Novgorod",
    CHE: "Chelyabinsk",
    UFA: "Ufa",
    VOL: "Volgograd",
    PRM: "Perm",
    VOR: "Voronezh",
    SAR: "Saratov",
    KRS: "Kursk",
    TUL: "Tula",
  },
};

export function getStateFullName(
  countryCode: string,
  stateCode: string
): string {
  if (!countryCode || !stateCode) return stateCode;
  const states = GLOBAL_STATES[countryCode];
  if (states && states[stateCode]) {
    return states[stateCode];
  }
  return stateCode;
}
